var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLowVolume(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.57,
    height: 29.857,
    viewBox: "0 0 29.57 29.857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#575f6b;stroke-width:0.5px;}.a,.c{stroke:#575f6b;}.b{fill:#ffa100;}.c{fill:none;stroke-linecap:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.676 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M392.983,22.784h-3.426a1.058,1.058,0,0,1-1.056-1.056V1.056A1.058,1.058,0,0,1,389.556,0h3.426a1.058,1.058,0,0,1,1.056,1.056V21.727A1.058,1.058,0,0,1,392.983,22.784ZM389.556.4a.657.657,0,0,0-.657.657V21.727a.657.657,0,0,0,.657.657h3.426a.657.657,0,0,0,.657-.657V1.056A.657.657,0,0,0,392.983.4Z",
    transform: "translate(-364.316)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M272.983,81.243h-3.426a1.058,1.058,0,0,1-1.056-1.056V63.056A1.058,1.058,0,0,1,269.556,62h3.426a1.058,1.058,0,0,1,1.056,1.056V80.187A1.058,1.058,0,0,1,272.983,81.243ZM269.556,62.4a.657.657,0,0,0-.657.657V80.187a.657.657,0,0,0,.657.657h3.426a.657.657,0,0,0,.657-.657V63.056a.657.657,0,0,0-.657-.657Z",
    transform: "translate(-252.168 -58.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M152.983,137.817h-3.426a1.058,1.058,0,0,1-1.056-1.056v-13.7A1.058,1.058,0,0,1,149.556,122h3.426a1.058,1.058,0,0,1,1.056,1.056v13.7A1.058,1.058,0,0,1,152.983,137.817ZM149.556,122.4a.657.657,0,0,0-.657.657v13.7a.657.657,0,0,0,.657.657h3.426a.657.657,0,0,0,.657-.657v-13.7a.657.657,0,0,0-.657-.657Z",
    transform: "translate(-140.02 -115.034)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M36.283,200.491H32.857a.857.857,0,0,1-.857-.857V189.357a.857.857,0,0,1,.857-.857h3.426a.857.857,0,0,1,.857.857v10.278A.857.857,0,0,1,36.283,200.491Z",
    transform: "translate(-31.173 -177.736)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 28.57,
    transform: "translate(1.176 27.024)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M104.57,428.5a2.57,2.57,0,1,1-2.57,2.57A2.57,2.57,0,0,1,104.57,428.5Z",
    transform: "translate(-99.176 -404.032)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowVolume);
export default __webpack_public_path__ + "static/media/low-volume.4a3135a1275c9dc72422b36ba4235990.svg";
export { ForwardRef as ReactComponent };